import { useParams } from 'react-router-dom';
import { ScoringProvider } from '../../Context/Scoring.context';
import Solution, { SolutionViewMode } from '../Solution/Solution.component';
import useSessionUser from '../../hooks/useSessionUser';

export const AssessmentSolution: React.FC = () => {
  const { orgzId, examinerId, processTypeId, deskId, examinerFunction, sheetId } = useParams() as {
    orgzId: string;
    examinerId: string;
    processTypeId: string;
    deskId: string;
    examinerFunction: string;
    sheetId?: string;
  };

  const { userAssessmentSessionInfo } = useSessionUser();

  return (
    <ScoringProvider
      orgzId={orgzId}
      examinerId={examinerId}
      assessmentSessionId={userAssessmentSessionInfo.assessmentSessionId}
      processTypeId={processTypeId}
      deskId={deskId}
      examinerFunction={examinerFunction}
      initialSheetId={sheetId}
    >
      <Solution mode={SolutionViewMode.assessment} />
    </ScoringProvider>
  );
};
